import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { PhoneFrame } from './PhoneFrame';
import { HomeScreen } from './HomeScreen';
import { VehicleSelection } from './VehicleSelection';
import { RideTracking } from './RideTracking';
import { PaymentConfirmation } from './PaymentConfirmation';
import { ActivityScreen } from './ActivityScreen';
import { AccountScreen } from './AccountScreen';
type Screen = 'home' | 'vehicle' | 'tracking' | 'payment' | 'activity' | 'account';
export function MiniRidesApp() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('home');
  // Helper to handle tab navigation
  const handleTabChange = (tab: 'home' | 'activity' | 'account') => {
    setCurrentScreen(tab);
  };
  return <div className="flex min-h-screen w-full items-center justify-center bg-slate-100 py-8" data-id="element-107">
      <PhoneFrame data-id="element-108">
        <AnimatePresence mode="wait" data-id="element-109">
          {currentScreen === 'home' && <HomeScreen key="home" onNavigate={() => setCurrentScreen('vehicle')} onTabChange={handleTabChange} data-id="element-110" />}

          {currentScreen === 'vehicle' && <VehicleSelection key="vehicle" onBack={() => setCurrentScreen('home')} onConfirm={() => setCurrentScreen('tracking')} data-id="element-111" />}

          {currentScreen === 'tracking' && <RideTracking key="tracking" onComplete={() => setCurrentScreen('payment')} data-id="element-112" />}

          {currentScreen === 'payment' && <PaymentConfirmation key="payment" onDone={() => setCurrentScreen('home')} data-id="element-113" />}

          {currentScreen === 'activity' && <ActivityScreen key="activity" onTabChange={handleTabChange} data-id="element-114" />}

          {currentScreen === 'account' && <AccountScreen key="account" onTabChange={handleTabChange} data-id="element-115" />}
        </AnimatePresence>
      </PhoneFrame>
    </div>;
}